import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { IncidentClosureAdminComponent } from './incident-closure-admin.component';

const routes: Routes = [
  { path: '', component: IncidentClosureAdminComponent, data: { title: 'Incident Closure Admin' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class IncidentClosureAdminRoutingModule {}

@NgModule({
  imports: [
    IncidentClosureAdminRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [IncidentClosureAdminComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class IncidentClosureAdminModule {}
